import { Link } from '@inertiajs/react'

const icons = {
  users: '👥',
  home: '🏠',
  link: '🔗',
  currency: '💰',
  building: '🏢',
  network: '🌐',
  chart: '📊'
}

const colors = {
  blue: 'bg-blue-50 text-blue-600',
  green: 'bg-green-50 text-green-600',
  purple: 'bg-purple-50 text-purple-600',
  yellow: 'bg-yellow-50 text-yellow-600'
}

export default function StatsCard({ title, value, subtitle, trend, trendLabel, icon, color = 'blue', href }) {
  const CardWrapper = href ? Link : 'div'
  const wrapperProps = href ? { href } : {}

  return (
    <CardWrapper
      {...wrapperProps}
      className={`bg-white rounded-lg shadow p-6 ${href ? 'hover:shadow-lg transition-shadow cursor-pointer' : ''}`}
    >
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-sm font-medium text-gray-600">{title}</h3>
        <div className={`w-10 h-10 rounded-lg ${colors[color]} flex items-center justify-center text-xl`}>
          {icons[icon]}
        </div>
      </div>

      <div className="text-3xl font-bold text-gray-900 mb-1">{value}</div>

      <div className="flex items-center justify-between">
        <p className="text-sm text-gray-600">{subtitle}</p>
        {trend !== undefined && (
          <span className={`text-xs font-medium ${
            trend > 0 ? 'text-green-600' : trend < 0 ? 'text-red-600' : 'text-gray-500'
          }`}>
            {trend > 0 && '+'}{trend} {trendLabel}
          </span>
        )}
      </div>
    </CardWrapper>
  )
}
